import { render, staticRenderFns } from "./DepositModal.vue?vue&type=template&id=7d081919&"
import script from "./DepositModal.vue?vue&type=script&lang=js&"
export * from "./DepositModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports